import type { InstrumentId } from "@trader/shared/MarketData"
import { Schema } from "effect"
import { type Drawing, parseDrawings } from "lightweight-charts-drawing"
import { documentSaver, loadDocument } from "../../documents.ts"
import { createDrawingsHub, type DrawingsHub } from "./drawingsHub.ts"

// Each symbol's drawings ("drawings:<instrument>" documents), shared live by
// every chart of the symbol (drawingsHub.ts). The document is the JSON list the
// drawing library exports; it's decoded here, at the boundary.

const decode = Schema.decodeUnknownOption(Schema.fromJsonString(Schema.Array(Schema.Unknown)))

const parse = (json: string | null): ReadonlyArray<Drawing> | null => {
  if (json === null) return []
  const list = decode(json)
  if (list._tag === "None") return null
  try {
    return parseDrawings(list.value)
  } catch {
    return null
  }
}

export const drawingsKey = (instrument: InstrumentId): string => `drawings:${instrument}`

// The saver reports refused saves back to the hub, which shows them on the pane.
let hub: DrawingsHub<Drawing> | null = null
const saver = documentSaver(600, (key, status) => hub?.saveStatus(key, status))

export const drawingsStore: DrawingsHub<Drawing> = createDrawingsHub<Drawing>({
  load: loadDocument,
  parse,
  saver,
  schedule: (deliver) => queueMicrotask(deliver)
})
hub = drawingsStore
